import React from 'react';
import './AboutSection.css';

const AboutSection = () => {
  return (
    <section id="why-choose-us" className="why-choose-us-section">
      <div className="container">
        <div className="why-choose-us-content">
          <div className="section-header">
            <h2>Why Choose Us</h2>
            <div className="underline"></div>
          </div>
          
          <div className="intro-text">
            <p>At ExamGuide Home tuitions, we unite Skilled tutors and motivated Students to achieve academic Success through focused learning and the right guidance.</p>
          </div>
          
          <div className="benefits-container">
            {/* For Parents Column */}
            <div className="benefits-column parents-benefits">
              <h3>
                <i className="fas fa-user-tie"></i> For Parents
              </h3>
              <ul className="benefits-list">
                <li>
                  <i className="fas fa-check-circle"></i>
                  <span>Verified and experienced tutors</span>
                </li>
                <li>
                  <i className="fas fa-check-circle"></i>
                  <span>Free Demo classes before you decide</span>
                </li>
                <li>
                  <i className="fas fa-check-circle"></i>
                  <span>Flexible timings</span>
                </li>
                <li>
                  <i className="fas fa-check-circle"></i>
                  <span>Available in online/offline mode</span>
                </li>
                <li>
                  <i className="fas fa-check-circle"></i>
                  <span>Quick tutor matching in 24-48 hrs</span>
                </li>
              </ul>
            </div>
            
            {/* For Tutors Column */}
            <div className="benefits-column tutors-benefits">
              <h3>
                <i className="fas fa-chalkboard-user"></i> For Tutors
              </h3>
              <ul className="benefits-list">
                <li>
                  <i className="fas fa-check-circle"></i>
                  <span>Simple & Free Registration process</span>
                </li>
                <li>
                  <i className="fas fa-check-circle"></i>
                  <span>Earn more with 30% Commission on first month unlike others charging 50% Commission</span>
                </li>
                <li>
                  <i className="fas fa-check-circle"></i>
                  <span>Flexible timings</span>
                </li>
                <li>
                  <i className="fas fa-check-circle"></i>
                  <span>Get more Students in your preferred locations</span>
                </li>
              </ul>
            </div>
          </div>
          
          <div className="promise-section">
            <p>Delivering better results for Students and Better growth for tutors<br />
            <strong>The true ExamGuide promise</strong></p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection; 